import React, { useState } from 'react';
import {
  Button, Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row, Alert, Spinner
} from 'reactstrap';
import { authApi, setAuth } from '../services/auth';

export function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await authApi.login(email, password);

      setAuth(response.token, response.user);
      onLogin();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bia-analyzer">
      <Row className="justify-content-center">
        <Col md="6" lg="5">
          <Card className="bia-card mt-5">
            <CardBody>
              <CardTitle tag="h2" className="text-center mb-4">
                Accedi a Sibilla
              </CardTitle>

              {error && <Alert color="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="password">Password</Label>
                  <Input
                    id="password"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    minLength={6}
                  />
                </FormGroup>
                <Button color="primary" block disabled={loading}>
                  {loading ? <><Spinner size="sm" className="me-1" /> Attendere...</> : 'Accedi'}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
